import { Button, ButtonsGroup } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useVatDeclarationsSettlePeriodModal } from '../../context/vatDeclarationsSettlePeriodModalContext'

export const ModalFooterNL = (): ReactElement => {
  const { t } = useTranslation()
  const { closeModal, isProcessing, settleVatDeclarationsPeriod } = useVatDeclarationsSettlePeriodModal()

  const handleCancelButtonClick = useCallback(() => {
    closeModal()
  }, [closeModal])

  const handleSettleButtonClick = useCallback(() => {
    settleVatDeclarationsPeriod()
  }, [settleVatDeclarationsPeriod])

  return (
    <ButtonsGroup>
      <Button variant="text" onClick={handleCancelButtonClick}>
        {t('cancel')}
      </Button>
      <Button onClick={handleSettleButtonClick} loading={isProcessing}>
        {t('vat_declarations.settlement_modal.footer.submit')}
      </Button>
    </ButtonsGroup>
  )
}
